export const ListQueryKey = 'thirdPaymentlist';
export const DetailQueryKey = 'thirdPayment';

export const Urls = {
  selectUrl: '/third/list',
  updateUrl: '/third/update',
  deleteUrl: '/third/delete',
  createUrl: '/third/create',
  detailUrl: '/third/info',
};
